// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3193":"9ea407f3","5932":"9ea407f3"}[chunkId] + ".chunk.css";
};